import React, { useEffect, useState } from "react";
import axios from "axios";
import RevenuePieChart from "./RevenuePieChart";
import TripsGraph from "./TripsGraph";
import DeployedVehiclesGraph from "./DeployedVehiclesGraph";
import ActiveInactiveVehiclesGraph from "./ActiveInactiveVehiclesGraph";
import { format } from "date-fns";

export default function MisDashboard() {
  const [misData, setMisData] = useState(null);
  const [date, setDate] = useState("");
  console.log("setDate",setDate);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchMisData = async () => {
      setLoading(true);
      setError(null);
      try {
        const formData = new URLSearchParams();
        if (date) formData.append("date_tag", date);

        const res = await axios.post(
          "https://staging.ohmelogistics.com/fetch_mis_data",
          formData,
          { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
        );

        if (res.data?.success && res.data?.misData) {
          setMisData(res.data.misData);
        } else {
          setError("Data is empty or API failed");
        }
      } catch (err) {
        console.error("🚨 API Error:", err);
        setError("Error connecting to server");
      } finally {
        setLoading(false);
      }
    };
    fetchMisData();
  }, [date]);

  if (loading)
    return <div className="flex items-center justify-center h-screen">Loading Dashboard...</div>;
  if (error)
    return <div className="flex items-center justify-center h-screen text-red-600">{error}</div>;
  if (!misData?.info)
    return (
      <div className="flex items-center justify-center h-screen text-gray-600">
        No data available
      </div>
    );

  const formattedDate = misData.date_tag
    ? format(new Date(misData.date_tag), "dd - MMM - yyyy")
    : "";

  return (
    <div className="h-screen w-screen flex flex-col bg-gray-100 overflow-hidden">
      {/* Header + Trips Side by Side */}
      <div className="flex items-center justify-between p-2 bg-gray-200 shadow">
        <h1 className="text-2xl font-bold">
          MIS Dashboard <span className="text-black">{formattedDate}</span>
        </h1>
        <div className="w-2/3 bg-white rounded-xl shadow-md p-2">
          <TripsGraph misData={misData} />
        </div>
      </div>

      {/* Charts Grid / Carousel */}
      <main className="flex-1 grid grid-cols-1 md:grid-cols-3 gap-4 p-2">
        <section className="bg-white flex flex-col p-2">
          <DeployedVehiclesGraph misData={misData} />
        </section>
        <section className="bg-white flex flex-col p-2">
          <ActiveInactiveVehiclesGraph misData={misData} />
        </section>
        <section className="bg-white flex flex-col p-2">
          <RevenuePieChart misData={misData} />
        </section>
      </main>
    </div>
  );
}
